import { FEATURED_FLAGS_LIST } from 'config'

const isFeatureEnabled = (name) => {
  return !!FEATURED_FLAGS_LIST.find((flag) => flag.name === name)?.isActive
}

export default isFeatureEnabled
